<app-header></app-header>
<div id="main_app" class="container-fluid">
  <div class="container">
    <div class="ranking_title">{{'EditInformationTitle' | translate}}</div>
    <div class="ranking_excerpt">{{'EditInformationDescription' | translate}}</div>
    <div class="edit_info">
      <form action="">
        <div class="row row_edit_info">
          <div class="col-12 col-md-6">
            <div class="edit_info_v2 my-3">
              <label for="full_name">{{ 'FullName' | translate }}</label>
              <input type="text" id="full_name" name="name" [(ngModel)]="user.name" (keyup.enter)="updateProfileWithImg()">
              <mat-spinner style="margin: 0 5px 0 0; vertical-align: middle; display: inline-block !important;" matSuffix [diameter]="20" color="hi" class="spinner" *ngIf="infoSpinner"></mat-spinner>
            </div>
            <div class="edit_info_v2 my-3">
              <label for="mobile_number">{{ 'MobileNumber' | translate}}</label>
              <input type="text" id="mobile_number" [(ngModel)]="user.mobile" value="mobile" name="mobile" [disabled]="isRegister === 'mobile'">
              <mat-spinner style="margin: 0 5px 0 0; vertical-align: middle; display: inline-block !important;" matSuffix [diameter]="20" class="spinner" *ngIf="infoSpinner"></mat-spinner>
            </div>
            <div class="edit_info_v2 my-3">
              <label for="email_address">{{ 'EmailAddress' | translate}}</label>
              <input type="email" id="email_address" [(ngModel)]="user.email" name="user.email" (keyup.enter)="updateProfileWithImg()" [disabled]="isRegister !== 'mobile'">
              <mat-spinner style="margin: 0 5px 0 0; vertical-align: middle; display: inline-block !important;" matSuffix [diameter]="20" class="spinner" *ngIf="infoSpinner"></mat-spinner>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="edit_image_profile">
              <div *ngIf="!pomodoroRepository.editCtrl" (click)="removeProfilePhoto()" class="delete_image_icon">
                <mat-icon>delete</mat-icon>
              </div>
              <mat-spinner class="remove-spinner" style="margin-right: 78px; margin-top: 90px; position: absolute;vertical-align: middle; display: inline-block !important;" matSuffix [diameter]="30" color="accent" *ngIf="removeImageSpinner"></mat-spinner>
              <img *ngIf="!pomodoroRepository.editCtrl" (click)="cropImage()" src="{{pomodoroRepository.profilePhoto}}" style="cursor: pointer" width="100%" height="100%" alt="">
              <div *ngIf="pomodoroRepository.editCtrl" class="camera-icon" (click)="cropImage()">
                <mat-icon>camera_alt</mat-icon>
              </div>
            </div><!-- .image_profile -->
          </div>
          <div class="col2_edit_info">
            <a (click)="updateProfileWithImg()">
              {{'SaveInformation' | translate}}
              <mat-spinner style="margin-bottom: -6px; vertical-align: middle; display: inline-block !important;" matSuffix [diameter]="20" color="accent" *ngIf="firstSpinner"></mat-spinner>
            </a>
          </div>
          <div class="clearfix"></div>
        </div><!-- .row_edit_info -->
        <div class="row_edit_info">
          <div class="notic_password">{{'PassowrdNotic' | translate}}
          </div>
          <div class="col_edit_info">
            <label for="password">{{'Password' | translate}}</label>
            <input type="password" id="password" [(ngModel)]="password.password" name="password.password">
          </div>
          <div class="col_edit_info">
            <label for="re_password">{{'RePassword' | translate}}</label>
            <input type="password" id="re_password" [(ngModel)]="password.password_confirmation" name="password.password_confirmation" (keyup.enter)="setPassword()">
          </div>
          <div class="col2_edit_info">
            <a (click)="setPassword()">
              {{'ChangePassword' | translate}}
              <mat-spinner style="margin-bottom: -6px; vertical-align: middle; display: inline-block !important;" matSuffix [diameter]="20" color="accent" *ngIf="secondSpinner"></mat-spinner>
            </a>
          </div>
          <div class="clearfix"></div>
        </div><!-- .row_edit_info -->
      </form>
    </div>
  </div><!-- .container -->
</div><!-- #main_app -->
<app-footer></app-footer>

